import { Pipe, PipeTransform } from '@angular/core';
import { SellInContract } from '../Model/SellInContract';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'SellInContractFilter',
  standalone: false
})
export class SellInContractFilterPipe implements PipeTransform {

  constructor(private datePipe: DatePipe) { }

  transform(sellInContracts: SellInContract[], searchTerm: string, field: string): SellInContract[] {
    if (!sellInContracts || !searchTerm) return sellInContracts;

    const lowerSearchTerm = searchTerm.toLowerCase();

    return sellInContracts.filter(contract =>
      this.matchesSearchTerm(contract, lowerSearchTerm)
    );
  }

  private matchesSearchTerm(contract: SellInContract, term: string): boolean {
    return (
      this.stringMatches(contract.marketCompanyName, term) ||
      this.stringMatches(contract.bannerName, term) ||
      this.stringMatches(contract.netSelling?.toString(), term) ||
      this.stringMatches(contract.size?.toString(), term) ||
      this.dateMatches(contract.applicationDate, term) ||
      this.stringMatches(contract.brandName, term) ||
      this.stringMatches(contract.brandQualityName, term)
    );
  }

  private stringMatches(value: string | null | undefined, term: string): boolean {
    return value?.toLowerCase().includes(term) ?? false;
  }

  private dateMatches(date: string | number | Date | null | undefined, term: string): boolean {
    if (!date) return false;
    const formattedDate = this.datePipe.transform(date as string | number | Date, 'MMMM dd, yyyy');
    return formattedDate?.toLowerCase().includes(term) ?? false;
  }
}
